import { SVGProps } from 'react'

export const Expand = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3L21 3V12H19.0714V4.92857L12 4.92857V3ZM4.92857 12L4.92857 19.0714H12V21H3L3 12H4.92857Z"
      fill="currentColor"
    />
  </svg>
)
